import { useState, useEffect } from 'react';

interface EditModeButtonProps {
  onEdit: () => void;
}

export default function EditModeButton({ onEdit }: EditModeButtonProps) {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const adminToken = localStorage.getItem('admin_token');
    setIsAdmin(adminToken === 'authenticated');
  }, []);

  if (!isAdmin) return null;

  return (
    <button
      onClick={onEdit}
      className="fixed bottom-8 right-8 bg-brand-600 text-white px-6 py-3 rounded-full shadow-lg hover:bg-brand-700 transition-all hover:scale-105 z-40 flex items-center gap-2 whitespace-nowrap"
      style={{ cursor: 'pointer' }}
    >
      <i className="ri-edit-line"></i>
      <span className="font-medium">Modifier cette page</span>
    </button>
  );
}